module.exports = __webpack_public_path__ + "img/logo-m2n.cac38d82.svg";